interface DetailSkeletonProps {
  fieldCount?: number
  badgeCount?: number
  showTabs?: boolean
}

export function DetailSkeleton({
  fieldCount = 8,
  badgeCount = 1,
  showTabs = false,
}: DetailSkeletonProps) {
  return (
    <div className="flex flex-col gap-6 animate-pulse">
      {/* Breadcrumb skeleton */}
      <div className="h-4 w-48 bg-muted rounded" />
      {/* Title + badges skeleton */}
      <div className="flex items-center gap-3">
        <div className="h-8 w-64 bg-muted rounded" />
        {Array.from({ length: badgeCount }).map((_, i) => (
          <div key={i} className="h-6 w-16 bg-muted rounded-full" />
        ))}
      </div>
      {/* Tabs skeleton */}
      {showTabs && <div className="h-10 w-96 bg-muted rounded-lg" />}
      {/* Grid skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
        {Array.from({ length: fieldCount }).map((_, i) => (
          <div key={i} className="flex flex-col gap-1">
            <div className="h-4 w-24 bg-muted rounded" />
            <div className="h-4 w-40 bg-muted rounded" />
          </div>
        ))}
      </div>
    </div>
  )
}
